var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAdmisrtation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2372_4058)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73438,
    y: 0.945312,
    width: 34,
    height: 34,
    rx: 10,
    fill: "#F6EFE9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7344 19.9453V21.9453C20.1431 21.9453 18.617 22.5775 17.4917 23.7027C16.3665 24.8279 15.7344 26.354 15.7344 27.9453H13.7344C13.7344 25.8236 14.5772 23.7887 16.0775 22.2885C17.5778 20.7882 19.6126 19.9453 21.7344 19.9453ZM21.7344 18.9453C18.4194 18.9453 15.7344 16.2603 15.7344 12.9453C15.7344 9.63031 18.4194 6.94531 21.7344 6.94531C25.0494 6.94531 27.7344 9.63031 27.7344 12.9453C27.7344 16.2603 25.0494 18.9453 21.7344 18.9453ZM21.7344 16.9453C23.9444 16.9453 25.7344 15.1553 25.7344 12.9453C25.7344 10.7353 23.9444 8.94531 21.7344 8.94531C19.5244 8.94531 17.7344 10.7353 17.7344 12.9453C17.7344 15.1553 19.5244 16.9453 21.7344 16.9453ZM30.7344 22.9453H31.7344V27.9453H23.7344V22.9453H24.7344V21.9453C24.7344 21.1497 25.0504 20.3866 25.6131 19.824C26.1757 19.2614 26.9387 18.9453 27.7344 18.9453C28.53 18.9453 29.2931 19.2614 29.8557 19.824C30.4183 20.3866 30.7344 21.1497 30.7344 21.9453V22.9453ZM28.7344 22.9453V21.9453C28.7344 21.6801 28.629 21.4257 28.4415 21.2382C28.2539 21.0507 27.9996 20.9453 27.7344 20.9453C27.4692 20.9453 27.2148 21.0507 27.0273 21.2382C26.8397 21.4257 26.7344 21.6801 26.7344 21.9453V22.9453H28.7344Z",
    fill: "#8F4300"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2372_4058",
    x: 0.734375,
    y: 0.945312,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.970833 0 0 0 0 0.952226 0 0 0 0 0.952226 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2372_4058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2372_4058",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdmisrtation);
export default __webpack_public_path__ + "static/media/User_admisrtation.1aeff84438e90b4cb0e794c4d24bfd4f.svg";
export { ForwardRef as ReactComponent };